// extracted by mini-css-extract-plugin
module.exports = {"root":"SiteCardList_root__2LOoD"};